const generateSequence = (customTimestamp?: number) => {
  let timestamp = Date.now();

  if (customTimestamp) {
    timestamp = customTimestamp;
  }

  return (timestamp * 10 ** 6).toString();
};

export default generateSequence;
